import type { ConsolidatedPreviewDetailsItemProps } from '@services/api/preview/types'

/**
 * As permissões de ação da Prévia vêm por linha em /api/previa/busca-previa-consolidada
 * (`canSubmit`, `canValidate`, `canApprove`, `canReturn`, `canJustify`, `canSeeMoreReturn`,
 * `canAdjust`). Os botões da página (ações em massa e ajustes) aparecem quando alguma linha
 * retornada — pai ou filha — tem a flag ligada.
 */
export const hasPreviewItemFlag = (
  items: ConsolidatedPreviewDetailsItemProps[] | null | undefined,
  flag: (item: ConsolidatedPreviewDetailsItemProps) => boolean
): boolean => (items ?? []).some((item) => flag(item) || hasPreviewItemFlag(item.children, flag))
